import withStyles from 'react-jss';

import ItemMenu from './component';
import styles from './styles';

export default withStyles(styles)(ItemMenu);
